import { Container } from '@mui/material';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { FScoreReport } from './f-score/f-score-report';
import { ChannelReports } from './impact/channel-reports';
import { ImpactReports } from './impact/impact-reports';
import { QaHeader } from './qa-header';
import { StatAlertReport } from './stat-alert/stat-alerts';

export const QaRouter: React.FC = () => {
    const { path } = useRouteMatch();

    return (
        <>
            <QaHeader />
            <Container maxWidth={false} className='pb-3 remaining-height'>
                <Switch>
                    <Route exact path={`${path}`}>
                        <p>Select QA subsection above.</p>
                    </Route>
                    <Route path={`${path}/impact`}>
                        <ImpactReports />
                    </Route>
                    <Route path={`${path}/f-score`}>
                        <FScoreReport />
                    </Route>
                    <Route path={`${path}/stat-alert`}>
                        <StatAlertReport />
                    </Route>
                    <Route path={`${path}/channel`}>
                        <ChannelReports />
                    </Route>
                </Switch>
            </Container>
        </>
    );
};
